import type {
  CreateFeedbackBody,
  CreateFeedbackMessageBody,
  FeedbackDto,
  FeedbackListQuery,
  FeedbackListResponse,
  FeedbackSummaryDto,
  UpdateFeedbackBody
} from '@malash-office/types';
import instanceAxios from '@/util/axios';
import { cleanParams } from '../planning/planningProjects.api';

/** פניות ומשוב — `/api/pvt/feedback`. */

const BASE = 'pvt/feedback';

export const fetchMyFeedback = async () => (await instanceAxios.get<FeedbackListResponse>(`${BASE}/mine`)).data;

export const fetchAllFeedback = async (params: FeedbackListQuery) =>
  (await instanceAxios.get<FeedbackListResponse>(BASE, { params: cleanParams(params) })).data;

export const fetchFeedbackSummary = async () => (await instanceAxios.get<FeedbackSummaryDto>(`${BASE}/summary`)).data;

export const fetchFeedback = async (id: number) => (await instanceAxios.get<FeedbackDto>(`${BASE}/${id}`)).data;

export interface CreateFeedbackVars {
  body: CreateFeedbackBody;
  files: File[];
  /** The page as it looked when the form opened, when "צרף צילום מסך" is ticked. */
  screenshot: Blob | null;
}

/** Multipart: the fields, the files the user added, and the screenshot as its own part. */
export const createFeedback = async ({ body, files, screenshot }: CreateFeedbackVars) => {
  const form = new FormData();
  Object.entries(body).forEach(([key, value]) => {
    if (value !== null && value !== undefined) form.append(key, String(value));
  });
  files.forEach(file => form.append('files', file));
  if (screenshot) form.append('screenshot', screenshot, 'screenshot.png');
  return (await instanceAxios.post<FeedbackDto>(BASE, form)).data;
};

export const updateFeedback = async ({ id, body }: { id: number; body: UpdateFeedbackBody }) =>
  (await instanceAxios.patch<FeedbackDto>(`${BASE}/${id}`, body)).data;

export const addFeedbackMessage = async ({ id, body }: { id: number; body: CreateFeedbackMessageBody }) =>
  (await instanceAxios.post<FeedbackDto>(`${BASE}/${id}/messages`, body)).data;

export const markFeedbackSeen = async (id: number) => {
  await instanceAxios.post(`${BASE}/${id}/seen`);
};

export const mergeFeedback = async ({ id, intoId }: { id: number; intoId: number }) =>
  (await instanceAxios.post<FeedbackDto>(`${BASE}/${id}/merge`, { intoId })).data;
